import React from "react";
import Sidemenu from "./Sidemenu";
import AdmMenu from "./AdmMenu";
import Footer from "./Footer";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

// import "../index.scss";
import "./App.css";

export function sidemenuFooterWrap(Component, componentProps = {}) {
  return function(componentProps) {
    // componentProps = { ...componentProps, style: {marginTop: '60px'}};
    return (
      <div style={{ width: '100%' }}>
        <Row>
          <Col
            sm={{ span: 12 }}
            md={{ span: 1 }}
            lg={{ span: 1 }}
            xl={{ span: 1 }}
          >
            <Sidemenu />
          </Col>
          <Col
            sm={{ span: 12 }}
            md={{ span: 9, offset: 1 }}
            lg={{ span: 9, offset: 1 }}
            xl={{ span: 10, offset: 1 }}
            className="col-comp-central"
            
          >
            <Component {...componentProps} />
          </Col>
        </Row>
        <Row>
          <Col sm={{ span: 10 }} md={{ span: 8 }} lg={{ span: 8 }}>
            <Footer />
          </Col>
        </Row>
      </div>
    );
  };
}

export function admMenuWrap(Component, componentProps = {}) {
  return function(componentProps) {
    // componentProps = { ...componentProps, style: {marginTop: '60px'}};
    return (
      <div style={{ width: '100%' }}>
        <Row>
          <Col
            sm={{ span: 12 }}
            md={{ span: 1 }}
            lg={{ span: 1 }}
            xl={{ span: 1 }}
          >
            <AdmMenu />
          </Col>
          <Col
            sm={{ span: 12 }}
            md={{ span: 9, offset: 1 }}
            lg={{ span: 9, offset: 1 }}
            xl={{ span: 10, offset: 1 }}
            className="col-comp-central"
            
          >
            <Component {...componentProps} />
          </Col>
        </Row>
      </div>
    );
  };
}

